import type { ShorthandValue, TileImageProps } from '@archipro-design/aria';
import { useAppDisplayModeContext, useTheme } from '@archipro-design/aria';
import { Grid } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import type { FC } from 'react';
import type { TagType } from '~/modules/product-tagging/type';
import { Link } from 'react-router';

import * as S from './TagPopverBody.style';
import { getAdditionalVariantCount } from '~/modules/page-builder/util/get-additional-variant-count';
import ProductTile from '~/modules/tile/component/product-tile/ProductImpressionTile';
import type { ColumnDimensionType } from '@modules/page-builder/types';
import VariantDot from '~/modules/tile/component/product-tile/VariantDot';

interface TagPopoverBodyProps {
    tags: TagType[];
    dimension: ColumnDimensionType;
}

const TagPopoverBody: FC<TagPopoverBodyProps> = ({ tags, dimension }) => {
    const { css } = useStyles({
        isPortrait: dimension.isPortrait,
    });
    const { mobile } = useAppDisplayModeContext();
    const theme = useTheme();

    const renderedTags = tags.map((tag, index) => {
        const productTag = tag.product;

        if (!productTag) {
            // eslint-disable-next-line array-callback-return
            return;
        }

        const variantsCount = productTag.variantsCount ?? 0;
        const additionalVariantCount = getAdditionalVariantCount(variantsCount);

        return (
            <ProductTile
                as={Link}
                to={productTag.link || ''}
                prefetch="intent"
                image={[
                    {
                        src: productTag.imageUrl || '',
                        alt: productTag.title,
                    },
                ]}
                professionalName={productTag.professional}
                productName={productTag.title}
                pricePrefix={productTag.pricePrefix}
                price={productTag.price}
                size="medium"
                variant="02"
                newDesignEnabled={true}
                key={index}
                tileImage={
                    {
                        overlay: { topActions: [] },
                        images: [productTag.imageUrl],
                    } as unknown as ShorthandValue<TileImageProps>
                }
                variables={{
                    color: theme.siteVariables.bodyColor,
                }}
                variants={productTag.variants?.map((v) => ({
                    children: (
                        <VariantDot
                            size={mobile ? 9 : 13}
                            colorCode={v.code ?? ''}
                            image={v.dot?.desktop}
                        />
                    ),
                }))}
                additionalVariantCount={additionalVariantCount}
                impression={{
                    itemID: productTag.id,
                    type: 'ProductTagLoggedIn',
                    professionalID: productTag.professionalID ?? 0,
                }}
            />
        );
    });

    return (
        <div className={css(S.TagsScrollableContainer)}>
            <Grid columns={'1fr 1fr'} className={css(S.TagContainer)}>
                {renderedTags}
            </Grid>
        </div>
    );
};

export default TagPopoverBody;
